import * as Models from "../.";
export interface IInvoiceDetailResponse extends Models.Customer.InvoiceDetailBaseResponse.IInvoiceDetailBaseResponse {
    name: string;
    lastName: string;
    invoiceNumber: string;
    excelergyLdcAccountNumber: string;
    address: string;
    fromDate: string;
    toDate: string;
    dueDate: string;
    emailAddress: string;
    usageAmount: number;
    rate: string;
    generationCharge: number;
    otherCharges: number;
    pastDue: number;
    taxes: number;
    balanceDue: number;
    co2Saved: number;
    acresSaved: number;
    community: string;
    transferAmount: number;
    solarSavings: number;
    billingSuccessful: boolean;
    approvalDate: string;
    invoiceType: string;
    note: string;
    productType: string;
    hasBattery: boolean;
}

export class InvoiceDetailResponse implements IInvoiceDetailResponse {
    documentKey: string;
    name: string;
    lastName: string;
    invoiceNumber: string;
    excelergyLdcAccountNumber: string;
    address: string;
    fromDate: string;
    toDate: string;
    dueDate: string;
    emailAddress: string;
    usageAmount: number;
    rate: string;
    generationCharge: number;
    otherCharges: number;
    pastDue: number;
    taxes: number;
    balanceDue: number;
    co2Saved: number;
    acresSaved: number;
    community: string;
    transferAmount: number;
    solarSavings: number;
    billingSuccessful: boolean;
    approvalDate: string;
    invoiceType: string;
    note: string;
    productType: string;
    hasBattery: boolean;
    billingFee: string;
}
